import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button from '../../Button'
import { getTaskIconByApiName } from '../Task.utils'

import {
  TASK_TYPE_LIST_ITEM_HEIGHT,
  TASK_TYPE_LIST_ITEM_ICON_HEIGHT,
} from './TaskTypeListItem.constants'

function TaskTypeListItem({
  activeItem,
  beforeIconHeight = TASK_TYPE_LIST_ITEM_ICON_HEIGHT,
  disabled,
  height = TASK_TYPE_LIST_ITEM_HEIGHT,
  icon,
  id,
  isCircle = true,
  name,
  ref,
  onClick,
  ...restProps
}) {
  function handleClick() {
    if (!disabled) {
      onClick?.({ icon, id, name })
    }
  }

  return (
    <div ref={ref}>
      <Button.Contained
        {...restProps}
        isGrey
        beforeIconProps={{
          Icon: getTaskIconByApiName(icon.name),
          height: beforeIconHeight,
        }}
        disabled={disabled}
        height={height}
        isActive={activeItem && activeItem?.id === id}
        isCircle={isCircle}
        tooltip={name}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={handleClick}
      />
    </div>
  )
}

export default TaskTypeListItem
